import {
    ADD_IDEAS,
    VIEW_IDEAS,
    UPDATE_IDEA,
    UPDATE_IDEA_STATUS,
    DELETE_IDEA,
    SELECTED_IDEA,
} from '../constants/action-types/ideas';

const initialState = {
    ideas: [],
    selectedIdea: null,
};

const ideasReducer = (state = initialState, action) => {
    switch (action.type) {
        case VIEW_IDEAS: {
            return { ...state, ideas: action.payload };
        }
        case ADD_IDEAS: {
            if (state.ideas?.length) {
                return { ...state, ideas: [...state.ideas, action.payload] }
            } else {
                return {...state, ideas: [action.payload]};
            }
        }
        case UPDATE_IDEA: {
            let brandIndex = state.ideas.findIndex(
                (val) => val._id === action.payload._id
            );
            let updatedPosts = [...state.ideas];
            updatedPosts[brandIndex] = action.payload;
            return {
                ...state,
                ideas: updatedPosts
            }
        }
        case UPDATE_IDEA_STATUS: {
            let brandIndex = state.ideas.findIndex(
                (val) => val._id === action.payload.ideaId
            );
            let updatedPosts = [...state.ideas];
            updatedPosts[brandIndex].status = action.payload.status;
            return {
                ...state,
                ideas: updatedPosts,
            };
        }
        case DELETE_IDEA: {
            // Payload is the bare ideaId string (see actions/idea.js).
            // The previous `action.payload.ideaId` accessor always
            // resolved to undefined, so the filter kept every idea —
            // deleting an idea looked like nothing happened in the
            // kanban / list until a full page reload.
            const removedId = action.payload && action.payload.ideaId
                ? action.payload.ideaId
                : action.payload;
            let updatedIdeas = state.ideas.filter(idea => idea._id !== removedId);
            return {
                ...state,
                ideas: updatedIdeas,
            };
        }
        case SELECTED_IDEA: {
            return {
                ...state,
                selectedIdea: action.payload
            }
        }
        default: return { ...state }
    }
};

export default ideasReducer;
